export const GRUNDFOS_BLUE = '#11497B';
export const DARK_BLUE = '#092844';
export const ATTENTION_BLUE = '#126AF3';
export const ATTENTION_BLUE_LIGHT = '#47A6FF';
export const BLUE1 = '#E9F1F7';
export const BLUE2 = '#BFD3E3';
export const BLUE3 = '#7497B2';
export const BLUE4 = '#092844';
export const GREEN1 = '#E7F1E7';
export const GREEN2 = '#C8DBC8';
export const GREEN3 = '#5D7469';
export const GREEN4 = '#37453E';
export const YELLOW1 = '#F7EDDB';
export const YELLOW2 = '#F5DAA9';
export const YELLOW3 = '#E3C181';
export const YELLOW4 = '#A36B50';
export const RED1 = '#F4E1D4';
export const RED2 = '#EDB99F';
export const RED3 = '#B75151';
export const RED4 = '#611E2E';


export const SIDEBAR_BG = '#092844';
export const SIDEBAR_TEXT = '#BFD3E3';
export const SIDEBAR_TEXT_ACTIVE = '#FFFFFF';
export const SIDEBAR_ITEM_BG = 'rgba(255,255,255,0.06)';
export const SIDEBAR_ITEM_ACTIVE_BG = 'rgba(18,106,243,0.2)';
export const SIDEBAR_ITEM_HOVER_BG = 'rgba(255,255,255,0.1)';
export const SIDEBAR_BORDER = 'rgba(255,255,255,0.08)';
export const SIDEBAR_SEARCH_BG = 'rgba(255,255,255,0.08)';

// Workspace semantic tokens (elevated card)
export const WORKSPACE_BG = '#092844';
export const CARD_BG = '#FFFFFF';
export const CARD_SHADOW = '0 8px 32px rgba(0,0,0,0.2), 0 2px 8px rgba(0,0,0,0.1)';

// Semantic tokens
export const BORDER_LIGHT = '#E9EEF2';
export const TEXT_PRIMARY = '#3C3C43';
export const TEXT_SECONDARY = '#8E8E93';
export const INPUT_BORDER = '#E1E5E9';
export const ERROR_RED = '#DC2626';
export const ERROR_RED_LIGHT = '#EF4444';
export const SUCCESS_GREEN = '#22C55E';
export const SUCCESS_GREEN_DARK = '#16A34A';
